import { TreeToolbar } from "slot-definitions"
import { CompareButton } from "../plugins/compare-button"
import { ScheduleViewMode } from "routes/schedule/scheduleViewMode"
import { Button } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { shouldShowScheduleEditorUndoButton } from "../lib/schedule-editor-toolbar-presenters"
import { Secure } from "lib/authorization/secure"
import { Frag } from "lib/@components/slot/frag"
import { AUTHORING_EDIT_SCHEDULES_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"
import { Bound } from "lib/@components/binding/Bound"
import { AmendsViewAllToggle } from "../../amends/components/amends-view-all-toggle"

export function useScheduleEditorToolbarPlugs({
    preview,
    hasUndo,
    projectId,
    scheduleId,
    isNewSchedule,
    onPreview,
    onEdit,
    onUndo,
    isLocked,
}) {
    const showUndoButton = shouldShowScheduleEditorUndoButton({ hasUndo, isLocked })

    TreeToolbar.usePlug(
        !preview && (
            <Bound isAuthoringScheduleEditor={true}>
                <ScheduleViewMode priority={200} />
            </Bound>
        ),
        [preview]
    )

    TreeToolbar.usePlug(!isNewSchedule && <CompareButton priority={70} />, [isNewSchedule])

    TreeToolbar.usePlug(
        !preview && (
            <Button
                key="preview"
                variant="outlined"
                onClick={onPreview}
                data-cy="schedule-editor-preview-button"
                startIcon={<Iconify icon="mdi:eye" />}
                priority={50}
            >
                Preview
            </Button>
        ),
        [preview, projectId, scheduleId]
    )

    TreeToolbar.usePlug(
        preview && !isLocked && (
            <Secure demand={AUTHORING_EDIT_SCHEDULES_DEMAND} fallback={<Frag />}>
                <Button
                    key="edit"
                    variant="contained"
                    onClick={onEdit}
                    data-cy="schedule-editor-edit-button"
                    startIcon={<Iconify icon="mdi:pencil" />}
                    priority={50}
                >
                    Edit
                </Button>
            </Secure>
        ),
        [preview, projectId, scheduleId, isLocked]
    )

    TreeToolbar.usePlug(
        showUndoButton && (
            <Button
                key="undo"
                variant="outlined"
                onClick={onUndo}
                data-cy="schedule-editor-undo-button"
                startIcon={<Iconify icon="mdi:undo" />}
                priority={90}
            >
                Undo
            </Button>
        ),
        [showUndoButton, onUndo]
    )

    TreeToolbar.usePlug(
        !preview && <AmendsViewAllToggle projectId={projectId} scheduleId={scheduleId} priority={300} />,
        [preview, projectId, scheduleId]
    )
}
